import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { Special } from 'src/app/models/special.model';
import { Category, Item } from 'src/app/models/menu.model';
import { DBService } from 'src/app/services/db.service';
import { ModalController } from '@ionic/angular';
import { ImageGalleryComponent } from '../image-gallery/image-gallery.component';

@Component({
  selector: 'app-special-detail',
  templateUrl: './special-detail.component.html',
  styleUrls: ['./special-detail.component.scss'],
})
export class SpecialDetailComponent implements OnInit {
  @Input() specialObj: Special;

  readonly UI_STANDARD: string = "standard"
  readonly UI_CHOOSE_LINK: string = "link"
  public selectedUI: string = this.UI_STANDARD

  selectColorExpanded: boolean;
  titleText: string = 'Bearbeite dein Special'

  constructor(public util: UtilService, public db: DBService, private modalCtrl: ModalController) {
    this.util.isModalOpen = true
  }

  ngOnInit() {
    if (!this.specialObj) {
      this.specialObj = new Special(this.db.currentRestaurantKey)
      this.specialObj.img = 'assets/imgs/specials/special_0.jpg'
      this.specialObj.isActive = false
      this.titleText = 'Erstelle ein neues Special'
    }

  }

  setUI(ui: string) {
    this.selectedUI = ui
  }

  selectBonuskarten() {
    this.specialObj.id2Link = -1
    this.specialObj.bonuscardSpecial = true
    this.selectedUI = this.UI_STANDARD
  }

  selectCat(cat: Category) {
    this.specialObj.id2Link = cat.id;
    this.specialObj.bonuscardSpecial = false
    this.selectedUI = this.UI_STANDARD
  }

  selectItem(item: Item) {
    this.specialObj.id2Link = item.id;
    this.specialObj.bonuscardSpecial = false
    this.selectedUI = this.UI_STANDARD
  }


  get linkText(): string {
    if (this.specialObj.bonuscardSpecial === true) return 'Bonuskarten'
    if (!this.specialObj.id2Link) return 'nicht gewählt'
    let article: any = this.db.findArticleByID(this.specialObj.id2Link)

    if (article) {
      return article.name
    }
    return "nicht gefunden"
  }

  async selectSpecialImg() {
    // Create a modal using MyModalComponent with some initial data
    const modal = await this.modalCtrl.create({
      component: ImageGalleryComponent,
      componentProps: { specialObj: this.specialObj }
    });
    await modal.present();

    await modal.onDidDismiss().then((res: any) => {
      this.util.isModalOpen = false
      if (res && res.data) {
        this.specialObj = res.data
      }
    })
  }

  selectColor(special: Special, color: string) {
    special.color = color
    this.selectColorExpanded = false;
  }

  toggleColors() {
    this.selectColorExpanded = true;
  }

  back() {
    this.modalCtrl.dismiss()
  }

  save() {
    if (!this.specialObj.title || this.specialObj.title.trim().length == 0) {
      this.util.presentToast("Dein Special benötigt einen Titel.", 3000, 'toast-warning')
      return
    }
    this.util.isModalOpen = false
    this.modalCtrl.dismiss(this.specialObj)
  }


}
